import { Users, Settings, ClipboardList, ShieldCheck, BookMarked, Lightbulb, Layers, Bookmark, FileText, BookOpen, GraduationCap, Calendar, BarChart3, AlertCircle, CheckCircle2, Folder, Briefcase, Target, Zap } from 'lucide-react';

// ─── Icon registry (must mirror ALLOWED_ICONS in backend) ─────
export const ICON_MAP = {
  Users, Settings, ClipboardList, ShieldCheck, BookMarked, Lightbulb, Layers,
  Bookmark, FileText, BookOpen, GraduationCap, Calendar, BarChart3, AlertCircle,
  CheckCircle2, Folder, Briefcase, Target, Zap,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);

export const COLOR_OPTIONS = [
  { id: 'violet',  label: 'Violet',  dot: 'bg-violet-500' },
  { id: 'amber',   label: 'Amber',   dot: 'bg-amber-500' },
  { id: 'blue',    label: 'Blue',    dot: 'bg-blue-500' },
  { id: 'rose',    label: 'Rose',    dot: 'bg-rose-500' },
  { id: 'slate',   label: 'Slate',   dot: 'bg-slate-500' },
  { id: 'emerald', label: 'Emerald', dot: 'bg-emerald-500' },
  { id: 'indigo',  label: 'Indigo',  dot: 'bg-indigo-500' },
  { id: 'pink',    label: 'Pink',    dot: 'bg-pink-500' },
  { id: 'cyan',    label: 'Cyan',    dot: 'bg-cyan-500' },
  { id: 'orange',  label: 'Orange',  dot: 'bg-orange-500' },
];

// ─── Starter template for new documents ──────────────────────
export const DOC_SECTION_TEMPLATE = [
  {
    heading: 'Overview',
    subheading: 'Brief context — what is this doc about?',
    blocks: [
      { type: 'paragraph', text: 'Write the overview paragraph here.' },
      { type: 'callout', tone: 'info', title: 'Quick tip', text: 'Use callouts to highlight important points.' },
    ],
  },
  {
    heading: 'Step-by-step',
    blocks: [
      { type: 'steps', items: [
        { title: 'First step', detail: 'Describe the first step in detail.' },
        { title: 'Second step', detail: 'Describe the second step.', hint: 'Optional hint.' },
      ]},
    ],
  },
];

export const BLOCK_TEMPLATES = {
  paragraph: { type: 'paragraph', text: 'New paragraph text...' },
  steps: { type: 'steps', items: [{ title: 'Step title', detail: 'Step detail' }] },
  bullets: { type: 'bullets', items: ['First bullet', 'Second bullet'] },
  callout: { type: 'callout', tone: 'info', title: '', text: 'Callout body' },
  table: { type: 'table', headers: ['Column 1', 'Column 2'], rows: [['Cell', 'Cell']] },
  faq: { type: 'faq', items: [{ question: 'Question?', answer: 'Answer.' }] },
};

/**
 * Convert common share URLs to an iframe-embeddable form.
 * Handles: Google Drive, Dropbox, direct PDFs.
 * Returns the original URL if no rewrite is needed.
 */
export function toEmbeddableUrl(url) {
  if (!url) return '';
  const u = url.trim();
  // Google Drive: /file/d/FILE_ID/view → /file/d/FILE_ID/preview
  const gdriveMatch = u.match(/drive\.google\.com\/file\/d\/([^/]+)/);
  if (gdriveMatch) {
    return `https://drive.google.com/file/d/${gdriveMatch[1]}/preview`;
  }
  // Google Docs / Sheets / Slides: add /preview
  const gdocsMatch = u.match(/docs\.google\.com\/(document|spreadsheets|presentation)\/d\/([^/]+)/);
  if (gdocsMatch) {
    return `https://docs.google.com/${gdocsMatch[1]}/d/${gdocsMatch[2]}/preview`;
  }
  // Dropbox: ?dl=0 → ?raw=1 for direct file access
  if (u.includes('dropbox.com') && u.includes('?dl=')) {
    return u.replace('?dl=0', '?raw=1').replace('?dl=1', '?raw=1');
  }
  return u;
}
